import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import ShowcaseSection from '../components/ShowcaseSection';
import HowItWorksSection from '../components/HowItWorksSection';
import WhySection from '../components/WhySection';
// import TestimonialSection from '../components/TestimonialSection';
// import VideoSection from '../components/VideoSection';
// import StatsSection from '../components/StatsSection';
import PartnerJoinSection from '../components/PartnerJoinSection';
import CtaSection from '../components/CtaSection';

// Dummy avatar imports
import user1 from '../assets/images/user1.webp';
import user2 from '../assets/images/user2.webp';
import user3 from '../assets/images/user3.webp';
import user4 from '../assets/images/user4.webp';
import user5 from '../assets/images/user5.webp';
import user6 from '../assets/images/user6.webp';
import user7 from '../assets/images/user7.webp';
import user8 from '../assets/images/user8.webp';
import user9 from '../assets/images/user9.webp';
import user10 from '../assets/images/user10.webp';

const userNames = [
  'Bayu', 'Rizka', 'Zacky', 'Akbar', 'Sinta',
  'Galuh', 'Yahya', 'Erna', 'Nanda', 'Annisa'
];

const userAvatars = [
  user1, user2, user3, user4, user5,
  user6, user7, user8, user9, user10
];

const LandingPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="font-sans text-gray-800 dark:text-gray-100">
      <HeroSection />
      <ShowcaseSection activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
      <HowItWorksSection />
      <WhySection />
      {/* <TestimonialSection /> */}
      {/* <VideoSection /> */}
      {/* <StatsSection /> */}
      <PartnerJoinSection /> {/* ✅ Section baru */}
      <CtaSection userNames={userNames} userAvatars={userAvatars} />
    </div>
  );
};

export default LandingPage;
